import { LobbyPlayer } from "./LobbyPlayer.js";
import type { GamePlayerData } from "../api/game/GamePlayerData.js";
import { LobbyPlayerType } from "./LobbyPlayerType.js";
import type { BotType } from "../game/BotType.js";
import type { APIPublicGamePreferences, APIUser } from "../api/api_schema.js";


export class BotLobbyPlayer extends LobbyPlayer {
    private readonly botType: BotType;

    constructor(botType: BotType, gameData: GamePlayerData | null) {
        super(LobbyPlayerType.BOT, gameData);
        this.botType = botType;
    }

    getBotType(): BotType {
        return this.botType;
    }

    override getBotTypeOrNull(): BotType | null {
        return this.botType;
    }

    override getUserOrNull(): APIUser | null {
        return null;
    }

    override isAnonymous(): boolean {
        return false;
    }

    override getShortName(): string {
        return this.botType.getName();
    }

    override getLongName(): string {
        return this.botType.getLongName();
    }

    override withPreferences(_preferences: APIPublicGamePreferences): LobbyPlayer {
        // Bot players don't have preferences.
        return this;
    }

    override withGameData(gameData: GamePlayerData): LobbyPlayer {
        return new BotLobbyPlayer(
            this.botType, gameData,
        );
    }

    override equals(other: LobbyPlayer): boolean {
        if (!LobbyPlayer._baseEquals(this, other))
            return false;
        if (!(other instanceof BotLobbyPlayer))
            return false;

        return this.botType === other.botType;
    }
}
